exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-card{border-radius:1.06667vw;border:1px solid #ebeef5;background-color:#fff;overflow:hidden;color:#303133;-webkit-transition:.3s;transition:.3s}.el-card.is-always-shadow,.el-card.is-hover-shadow:focus,.el-card.is-hover-shadow:hover{-webkit-box-shadow:0 .53333vw 3.2vw 0 rgba(0,0,0,.1);box-shadow:0 .53333vw 3.2vw 0 rgba(0,0,0,.1)}.el-card__header{padding:4.8vw 5.33333vw;border-bottom:1px solid #ebeef5;-webkit-box-sizing:border-box;box-sizing:border-box}.el-card__body{padding:5.33333vw}", ""]);

// exports
